import request from './AxiosRequest';

const add = (params) =>
	request({
		method: 'POST',
		url: '/Services/api/registration/signup',
		data: params
	});

const SignUp = {
	add
}

export default SignUp;
